import { Component, OnInit } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { FormBuilder, FormGroup, Validators, ReactiveFormsModule, AbstractControl } from '@angular/forms';
import { AuthServiceService } from '../../shareModule/services/auth-service.service';
import { LocalServiceService } from '../../shareModule/services/local-service.service';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { HttpClient } from '@angular/common/http';
import Swal from 'sweetalert2'
import { NewLoginModalComponent } from '../new-login-modal/new-login-modal.component';
@Component({
  selector: 'app-new-signup-modal',
  templateUrl: './new-signup-modal.component.html',
  styleUrls: ['./new-signup-modal.component.scss']
})
export class NewSignupModalComponent implements OnInit {

  userSignUp: FormGroup;
  submitted = false;
  error = "";
  yourIp: any;

  constructor(public activeModal: NgbActiveModal,
    private modalService: NgbModal,
    private toastr: ToastrService,
    private http: HttpClient,
    private auth: AuthServiceService,
    private local: LocalServiceService,
    private router: Router,
    private formBuilder: FormBuilder) { }

  ngOnInit(): void {
    this.userSignUp = this.formBuilder.group({
      usersEmail: ['', [Validators.required, Validators.email]],
      usersPassword: ['', [Validators.required, Validators.minLength(5)]],
      usersPasswordConfirm: ['', [Validators.required, Validators.minLength(5)]]
    });
    this.getIPAddress();
  }

  get userIn() { return this.userSignUp.controls; }

  usersignup() {
    this.submitted = true;
    if (this.userSignUp.invalid) {
      return;
    }
    // let myIp = this.local.getMyIp();
    // if (!myIp) {
    //   myIp = this.yourIp;
    // }
    let data = { 'email': this.userIn.usersEmail.value, 'password': this.userIn.usersPassword.value, 'cpassword': this.userIn.usersPasswordConfirm.value };

    if(data.password.trim() != data.cpassword.trim()) {
      this.toastr.error('Passwords do not match.');
      return;
    }

    this.auth.signup(data).subscribe((response: any) => {
      this.toastr.success(response.message);
      this.modalService.dismissAll();
      Swal.fire({
        title: 'Signup successful!',
        text: "We have sent an email with a confirmation link to your email address. Please check your junk mail if you did not receive any Email notification.",
        icon: 'success',
        showDenyButton: true,
        confirmButtonColor: '#141631',
        denyButtonColor: '#33D4A0',
        confirmButtonText: 'OK',
        denyButtonText: 'RESEND EMAIL',
      }).then((result) => {
        if (result.isConfirmed) {
          
        } else if (result.isDenied) {
          this.resend_verification_email(response.body.id);
        }
      })

      // this.local.saveLoginUserData(response.body);
      // this.router.navigate(['/home']);
      // let data = { 'ipAddress': myIp.ip };
      // this.auth.save_ip_address(data).subscribe((response: any) => {
      // }, (e) => {
      // })

    }, (e) => {
      if (e.status == 400) {
        this.toastr.error(e.error.message)
        this.modalService.dismissAll()
      }
    })
  }

  resend_verification_email(id) {
    let formData = new FormData();
    formData.append("id", id);
    this.auth.signup_resend_verification_email(formData).subscribe((response: any) => {
      Swal.fire({
        title: 'Email sent!',
        text: "We have sent an email with a confirmation link to your email address. Please check your junk mail if you did not receive any Email notification.",
        icon: 'success',
        confirmButtonColor: '#141631',
        confirmButtonText: 'OK'
      })
      this.modalService.dismissAll();
    }, (e) => {
      if (e.status == 400) {
        this.toastr.error(e.error.message)
        this.modalService.dismissAll()
      }
    })
  }

  dismiss() { this.modalService.dismissAll(); }

  getIPAddress() {
    this.http.get("https://api.ipify.org?format=json").subscribe((res: any) => {
      this.yourIp = res.ip;
    });
  }

  open_login_modal() {
    this.modalService.dismissAll();
    this.modalService.open(NewLoginModalComponent, { size: 'lg', ariaLabelledBy: 'modal-basic-title', windowClass: 'v2_login_model', centered: true });
  }

}

// export function checkIfPasswordsdMatch (c: AbstractControl) {
//   // console.log(c,'====================================c')
//   //safety check
//   if (c.get('usersPassword').value != c.get('usersPasswordConfirm').value) { this.is_confirm_password = 0; }
//   else { this.is_confirm_password = 1; }
//   // carry out the actual date checks here for is-endDate-after-startDate
//   // if valid, return null,
//   // if invalid, return an error object (any arbitrary name), like, return { invalidEndDate: true }
//   // make sure it always returns a 'null' for valid or non-relevant cases, and a 'non-null' object for when an error should be raised on the formGroup
// }